<template>
  <app-slide>
    <article class="layout" id="start">
        <div class="container">
          <div class="row">
              <div class="col-xs-12 text-content">
                  <h2 class="margin-bottom-2">{{getTranslation('venues')}}</h2>
                  <div v-html="content.body"></div>
              </div>
              <div class="col-xs-12 text-content">
                <h2 class="margin-top-4 margin-bottom-2">{{parcour.title}}</h2>
                <div v-html="parcour.body"></div>
                <gmap-map
                    :center="this.center"
                    :zoom="13"
                    :options="{styles: styles, pixelOffset:pixelOffset, gestureHandling: 'cooperative',mapTypeControl:false,streetViewControl:false}"
                    ref="parcourMap"
                    class="map-canvas margin-top-4 margin-bottom-4"
                  >
                  <gmap-marker
                    :key="index"
                    v-for="(m, index) in items"
                    :position="m.position"
                    :draggable="false"
                    :label="m.letter"
                  ></gmap-marker>
                  </gmap-map>
              </div>


              <div class="col-xs-12">
                  <ul class="list-style margin-bottom-4">
                    <router-link tag="li" :to="getUrl(item.code)" v-for="item in items" :key="item.id">
                      <span>{{item.letter}} {{item.title}}</span>
                      <span class="code">99.{{item.code}}</span>
                    </router-link>
                  </ul>
              </div>
        
          </div>
          </div>
    </article>
  </app-slide>
</template>


<script>
  import {store} from '../store/store'
  import appSlide from '../transitions/AppSlide'
  import mixinLanguages from '../mixins/Language'
  // import HomeRiboca from '../components/HomeRiboca'
  // import slide from '../mixins/PageSlide'
  export default {
    name: 'artistIndex',
    components: {
      appSlide
    },
    mixins: [mixinLanguages],
    data() {
      return {
        items:[],
        content: '',
        parcour:'',
        // icon: {url:'https://digital.rigabiennial.com/static/map-marker.png'},
        markers:[],
        center: {'lat':56.955281, 'lng':24.104617},
        pixelOffset: {
              width: 0,
              height: -35
        },
        styles: [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#444444"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"saturation":"-100"},{"lightness":"57"}]},{"featureType":"poi","elementType":"geometry.stroke","stylers":[{"lightness":"1"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"transit.station.bus","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"transit.station.bus","elementType":"labels.text.fill","stylers":[{"saturation":"0"},{"lightness":"0"},{"gamma":"1.00"},{"weight":"1"}]},{"featureType":"transit.station.bus","elementType":"labels.icon","stylers":[{"saturation":"-100"},{"weight":"1"},{"lightness":"0"}]},{"featureType":"transit.station.rail","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"transit.station.rail","elementType":"labels.text.fill","stylers":[{"gamma":"1"},{"lightness":"40"}]},{"featureType":"transit.station.rail","elementType":"labels.icon","stylers":[{"saturation":"-100"},{"lightness":"30"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#d2d2d2"},{"visibility":"on"}]}],
        infoContent: '',
        infoWindowPos: null,
        infoWinOpen: false,
        currentMidx: null,
        poly:{},
        parcourCoords:[],
        polylines:[],
        color:'#ff0000',
      }
    },
    mounted () {
      this.getIntro();
      this.getVenues();
      this.getParcour();
      let thisUrl = '99/00';
      store.dispatch('setDestUrl', thisUrl);
      store.dispatch('setDestChange', false);
    },
    computed:{
      lang() { 
        return this.$store.state.langUrl;
      }
    },
    watch: {
      // use the watch to react on the value change.
      lang(newValue) {
        this.getIntro();
        this.getVenues();
        this.getParcour();
      },
      items(updatedItems) {
          
          let bounds = new google.maps.LatLngBounds();
          let coords =  [];
          for (let m of this.items) {
            coords.push(m.position);
            bounds.extend(m.position)
          }
          // for (let i=0;i<this.items-1; i++) {
          //   bounds.extend(this.items[i].position);
          // }
          this.createPolys(coords);
          // this.$refs.map.$mapObject.fitBounds(bounds)
          // this.$refs.parcourMap.$mapObject.fitBounds(bounds)
      }
    },
    methods: {
      getIntro: function() {
        let baseUrl = this.$store.getters.getBaseUrl;
        let lang = this.$store.getters.getLangState;
        let url = baseUrl + lang + '/api/mobile/v1/venues-intro.json';
        this.$http.get(url).then((response) => {
          this.content = response.data.data[0];
        })
      },
      getParcour: function() {
        let baseUrl = this.$store.getters.getBaseUrl;
        let lang = this.$store.getters.getLangState;
        let url = baseUrl + lang + '/api/mobile/v1/parcour.json';
        this.$http.get(url).then((response) => {
          this.parcour = response.data;
        });
      },
      createPolys(allCoordinates) {
        let map = this.$refs.parcourMap.$mapObject;
        var polyline = new google.maps.Polyline({
            path: allCoordinates,
            strokeColor: this.color,
            strokeOpacity: 1.0,
            strokeWeight: 2,
            geodesic: true,
            icons: [{
                icon: {path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW},
                offset: '100%',
                repeat: '5%'
            }]
         });
        polyline.setMap(map);
        this.polylines.push(polyline);
      },
      getVenues: function() {
        let baseUrl = this.$store.getters.getBaseUrl;
        let lang = this.$store.getters.getLangState;
        let url = baseUrl + lang + '/api/mobile/v1/venues.json';
        this.$http.get(url).then((response) => {
          this.items = response.data.data;
        })
      },
      getUrl(code) {
        return String('/99/' + code);
      },
      toggleInfoWindow: function(marker, idx) {
            console.log('marker');
            this.infoWindowPos = marker.position;
            this.infoContent = marker.infoText;
            //check if its the same marker that was selected if yes toggle
            if (this.currentMidx == idx) {
              this.infoWinOpen = !this.infoWinOpen;
            }
            //if different marker set infowindow to open and reset current marker index
            else {
              this.infoWinOpen = true;
              this.currentMidx = idx;
            }
      }
    }
  }
</script>

<style lang="scss">
  .map-canvas {
    width: 100%;
    height: 40vh;
  }
</style>



// WEBPACK FOOTER //
// src/views/VenueIndex.vue